import React from "react";
import styled from "styled-components";
import { CalciteIcon } from "@esri/calcite-components-react";

import { I18nextProvider, useTranslation } from "react-i18next";
import instance from "../../utils/i18n";

const StyledAcceptsVouchers = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #262525;
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 4px;
`;

const AcceptsVouchersIndicator = ({ acceptsVouchers }: { acceptsVouchers?: boolean }) => {
  const { t, i18n } = useTranslation("components", { i18n: instance });

  if (!acceptsVouchers) return null;

  return (
    <I18nextProvider i18n={i18n}>
      <StyledAcceptsVouchers className="accepts-vouchers-indicator">
        <CalciteIcon
          icon="check-circle"
          scale="s"
          style={{ "--calcite-ui-icon-color": "#262525" } as React.CSSProperties}
        />
        {t("locCard.acceptsVouchers")}
      </StyledAcceptsVouchers>
    </I18nextProvider>
  );
};

export default AcceptsVouchersIndicator;
